import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth/index'
import notification from './notification/index'
import subscribers from './subscribers/index'
import user from './user/index'
import registrars from './registrars/index'
import registration from './registration/index'
import verify from './verify/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navTitle: 'Абоненты'
  },
  mutations: {
    SAVE_NAV_TITLE(state, payload) {
      state.navTitle = payload
    }
  },
  actions: {},
  modules: { auth, notification, subscribers, user, registrars, registration, verify }
})
